import React from 'react';
import Table from '../../components/Table/Table';
import Row from '../../components/Table/Row/Row';
import Cell from '../../components/Table/Row/Cell/Cell';
import Event from './Event';
import { FairDate } from '../../services/Utils/Date';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const useStyles = createUseStyles({
  date: {
    width: '210px',
  },
});

const EventList = ({ events, resultLimit }) => {
  const classes = useStyles();

  if (!events) {
    return <p>No Events...</p>;
  }
  return (
    <>
      <Table>
        <Row key='header'>
          <Cell header>Time</Cell>
          <Cell header>User</Cell>
          <Cell header>Info</Cell>
        </Row>
        {events && events.length > 0 ? (
          Object.values(events).map((row) => (
            <Row key={row.id}>
              <Cell className={classes.date}>{FairDate(row.timestamp.toDate(), true)}</Cell>
              <Cell>{row.user && <Link to={'../users/' + row.user.id}>{row.user.name}</Link>}</Cell>
              <Cell>
                <Event event={row} />
              </Cell>
            </Row>
          ))
        ) : (
          <Row>
            <Cell colSpan='3'>No rows</Cell>
          </Row>
        )}
      </Table>
      <div>
        <p>Total events showing:{events.length}</p>
        {events.length === resultLimit && (
          <p>Limit reached, please decrease your from and to date.</p>
        )}
      </div>
    </>
  );
};

export default EventList;
